<app-common-modal-wrapper
  [icon]="config.modalIcon ?? 'ic-refresh-20'"
  [header]="config.modalHeader ?? ''"
  [isLoading]="isLoading()"
  (close)="close()"
  (submitModal)="submit()"
>
  <app-input
    [label]="config.controlLabel ?? ''"
    [helperText]="config.controlHelperText ?? ''"
    [placeholder]="config.controlPlaceholder ?? ''"
    [formControl]="control"
    [customErrors]="config.controlCustomErrors ?? {}"
  />
</app-common-modal-wrapper>
